import { useEffect, useState } from 'react'

export function useBrowserType() {
    const [isEmbeddedBrowser, setIsEmbeddedBrowser] = useState<boolean>(false)
    const [userAgent, setUserAgent] = useState<string | undefined>(undefined)

    useEffect(() => {
        if (navigator?.userAgent) {
            setIsEmbeddedBrowser(
                !!(navigator.userAgent.includes('AppName') || navigator.userAgent.includes('Instagram'))
            )
            setUserAgent(navigator.userAgent)
        }
    }, [])

    return { isEmbeddedBrowser, userAgent }
}
